import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './careers-detail-component.component.scss';
import axios from 'axios';
import * as $ from 'jquery';
var CareersDetailComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CareersDetailComponent, _super);
    function CareersDetailComponent(element) {
        return _super.call(this, element) || this;
    }
    CareersDetailComponent.prototype.init = function () {
        this.buttonTextApplyNow = "Apply Now";
        this.buttonTextSaveJob = "Save Job";
        this.buttonTextUnsaveJob = "Remove Saved Job";
        this.dataTranslatePurpose = "Job Purpose";
        this.dataTranslateResponsibilities = "Key Responsibilites";
        this.dataTranslateQualifications = "Qualifications";
        this.dataTranslatePromise = "Our People Promise to You";
        this.dataTranslateDepartment = "Career Area";
        this.dataTranslateLocation = "Location";
        this.dataTranslateOverview = "Job Overview";
        this.dataTranslateJobId = "Job ID";
        this.dataTranslateDatePosted = "Date Posted";
        this.dataTranslateJobType = "Job Type";
        this.container = this.element;
        this.containerLoader = this.element.querySelector('.careers-detail-component__loader');
        this.containerContainer = this.element.querySelector('.careers-detail-component__container');
        this.containerTitle = this.element.querySelector('.js-careers-title');
        this.containerDepartment = this.element.querySelector('.js-careers-department');
        this.containerLocation = this.element.querySelector('.js-careers-location');
        this.containerType = this.element.querySelector('.js-careers-type');
        this.containerID = this.element.querySelector('.js-careers-id');
        // this.containerDate = this.element.querySelector('.js-careers-date');
        this.containerContentPurpose = this.element.querySelector('.js-careers-content-purpose');
        this.containerContentResponsibilities = this.element.querySelector('.js-careers-content-resposibility');
        this.containerContentQualifications = this.element.querySelector('.js-careers-content-qualifications');
        // this.containerContentSummary = this.element.querySelector('.js-careers-content-summary');
        this.containerButtons = Array.from(this.element.querySelectorAll('.careers-detail-component__buttons'));
        this.containerTranslateOverview = this.element.querySelector('.js-translate-pt-overview');
        this.containerTranslatePurpose = this.element.querySelector('.js-translate-pt-purpose');
        this.containerTranslateResponsibility = this.element.querySelector('.js-translate-pt-resposibility');
        this.containerTranslateQualifications = this.element.querySelector('.js-translate-pt-qualifications');
        this.containerTranslatePromise = this.element.querySelector('.js-translate-pt-summary');
        this.json = {};
        var getUrl = location.search;
        var patternJobId = /[?&]jobID=/;
        if (patternJobId.test(getUrl)) {
            this.urlJobId = this.urlParams('jobID');
        }
        var patternSite = /[?&]jobSite=/;
        if (patternSite.test(getUrl)) {
            this.urlSite = this.urlParams('jobSite');
        }
        var patternLocale = /[?&]jobLocale=/;
        if (patternLocale.test(getUrl)) {
            this.urlLocale = this.urlParams('jobLocale');
            if (this.urlLocale === "pt") {
                ////////////////////////////
                ////////////////////////////
                /// TRANSLATiONS
                ////////////////////////////
                ////////////////////////////
                if (this.element.getAttribute('data-pt-save')) {
                    this.dataButtonSave = this.element.getAttribute('data-pt-save');
                }
                else {
                    this.dataButtonSave = "Save Job";
                }
                if (this.element.getAttribute('data-pt-unsave')) {
                    this.dataButtonUnsave = this.element.getAttribute('data-pt-unsave');
                }
                else {
                    this.dataButtonUnsave = "Unsave Job";
                }
                if (this.element.getAttribute('data-pt-apply')) {
                    this.dataButtonApply = this.element.getAttribute('data-pt-apply');
                }
                else {
                    this.dataButtonApply = "Apply Now";
                }
                if (this.element.getAttribute('data-pt-purpose')) {
                    this.dataTranslatePurpose = this.element.getAttribute('data-pt-purpose');
                }
                else {
                    this.dataTranslatePurpose = "Job Purpose";
                }
                if (this.element.getAttribute('data-pt-responsibilities')) {
                    this.dataTranslateResponsibilities = this.element.getAttribute('data-pt-responsibilities');
                }
                else {
                    this.dataTranslateResponsibilities = "Key Responsibilites";
                }
                if (this.element.getAttribute('data-pt-qualifications')) {
                    this.dataTranslateQualifications = this.element.getAttribute('data-pt-qualifications');
                }
                else {
                    this.dataTranslateQualifications = "Qualifications";
                }
                if (this.element.getAttribute('data-pt-promise')) {
                    this.dataTranslatePromise = this.element.getAttribute('data-pt-promise');
                }
                else {
                    this.dataTranslatePromise = "Our People Promise to You";
                }
                if (this.element.getAttribute('data-pt-department')) {
                    this.dataTranslateDepartment = this.element.getAttribute('data-pt-department');
                }
                else {
                    this.dataTranslateDepartment = "Department";
                }
                if (this.element.getAttribute('data-pt-location')) {
                    this.dataTranslateLocation = this.element.getAttribute('data-pt-location');
                }
                else {
                    this.dataTranslateLocation = "Location";
                }
                if (this.element.getAttribute('data-pt-overview')) {
                    this.dataTranslateOverview = this.element.getAttribute('data-pt-overview');
                }
                else {
                    this.dataTranslateOverview = "Job Overview";
                }
                if (this.element.getAttribute('data-pt-jobid')) {
                    this.dataTranslateJobId = this.element.getAttribute('data-pt-jobid');
                }
                else {
                    this.dataTranslateJobId = "Job ID";
                }
                if (this.element.getAttribute('data-pt-dateposted')) {
                    this.dataTranslateDatePosted = this.element.getAttribute('data-pt-dateposted');
                }
                else {
                    this.dataTranslateDatePosted = "Date Posted";
                }
                if (this.element.getAttribute('data-pt-jobtype')) {
                    this.dataTranslateJobType = this.element.getAttribute('data-pt-jobtype');
                }
                else {
                    this.dataTranslateJobType = "Job Type";
                }
                this.buttonTextSaveJob = this.dataButtonSave;
                this.buttonTextUnsaveJob = this.dataButtonUnsave;
                this.buttonTextApplyNow = this.dataButtonApply;
                this.translations();
            }
        }
        if (localStorage.getItem('sbgCareersSaved')) {
            this.storageCareers = JSON.parse(localStorage.getItem('sbgCareersSaved'));
        }
        else {
            this.storageCareers = [];
        }
        this.httpContent();
    };
    CareersDetailComponent.prototype.bindEvents = function () {
        var _this = this;
        this.containerButtons.map(function (container) {
            var buttonSave = container.querySelector('.button--white');
            buttonSave.innerHTML = _this.buttonTextSaveJob;
            var buttonApply = container.querySelector('.button--main');
            buttonApply.innerHTML = _this.buttonTextApplyNow;
            buttonSave.addEventListener('click', function (e) {
                var target = e.target;
                var postId = target.getAttribute('data-postid');
                console.log(postId);
                if (target.classList.contains('js-unsave-job')) {
                    _this.unsaveJob(postId);
                    _this.containerButtons.map(function (container) {
                        var buttonSave = container.querySelector('.button--white');
                        buttonSave.classList.remove('js-unsave-job');
                        buttonSave.innerHTML = _this.buttonTextSaveJob;
                    });
                }
                else {
                    _this.saveJob(postId);
                    _this.containerButtons.map(function (container) {
                        var buttonSave = container.querySelector('.button--white');
                        buttonSave.classList.add('js-unsave-job');
                        buttonSave.innerHTML = _this.buttonTextUnsaveJob;
                    });
                }
            });
            buttonApply.addEventListener('click', function (e) {
                $('html,body').animate({
                    scrollTop: 0
                }, 'slow');
                $('div.careers-detail-component__container').addClass('d-none');
                $('div.careers-detail-component__iframe').removeClass('d-none');
            });
        });
    };
    CareersDetailComponent.prototype.httpContent = function () {
        var _this = this;
        // containers
        var container = this.container;
        var containerLoader = this.containerLoader;
        var containerContainer = this.containerContainer;
        var containerTitle = this.containerTitle;
        var containerDepartment = this.containerDepartment;
        var containerLocation = this.containerLocation;
        var containerType = this.containerType;
        var containerID = this.containerID;
        // let containerDate: any = this.containerDate;
        var containerContentPurpose = this.containerContentPurpose;
        var containerContentResponsibilities = this.containerContentResponsibilities;
        var containerContentQualifications = this.containerContentQualifications;
        // let containerContentSummary: any = this.containerContentSummary;
        var containerButtons = this.containerButtons;
        var storageCareers = this.storageCareers;
        // data
        var dataTranslateDepartment = this.dataTranslateDepartment;
        var dataTranslateJobType = this.dataTranslateJobType;
        var dataTranslateJobId = this.dataTranslateJobId;
        var dataTranslateDatePosted = this.dataTranslateDatePosted;
        var dataTranslateLocation = this.dataTranslateLocation;
        var buttonTextUnsaveJob = this.buttonTextUnsaveJob;
        // functions
        var checkIfSaved = this.checkIfSaved;
        var createIframe = this.createIframe;
        // attributes
        var postData = '';
        postData += "?site=" + this.urlSite;
        postData += "&locale=" + this.urlLocale;
        postData += "&limit=100";
        postData += "&offset=0";
        if (this.urlJobId) {
            postData += '&jobID=' + this.urlJobId;
        }
        // date
        var todaysDate = new Date();
        var fullDate = todaysDate.getFullYear().toString() + todaysDate.getMonth().toString() + todaysDate.getDate().toString() + todaysDate.getHours().toString() + todaysDate.getMinutes().toString();
        postData += "&time=" + fullDate;
        // variables
        var url = "/sbutils/getJobByID" + postData;
        // service
        axios.get(url).then(function (response) {
            _this.json = response.data;
            var date = new Date(_this.json.results[0].datePosted).toLocaleDateString();
            containerTitle.innerHTML = _this.json.results[0].title;
            containerDepartment.innerHTML = dataTranslateDepartment + ": " + _this.json.results[0].FLD_JPM_BUSINESS_LINE;
            containerLocation.innerHTML = dataTranslateLocation + ": " + _this.json.results[0].jobLocation[0].address.addressLocality + ", " + _this.json.results[0].jobLocation[0].address.addressRegion + ", " + _this.json.results[0].FLD_JPM_COUNTRY;
            containerType.innerHTML = dataTranslateJobType + ": " + _this.json.results[0].employmentType;
            containerID.innerHTML = dataTranslateJobId + ": " + _this.json.results[0].reqId;
            // containerDate.innerHTML = dataTranslateDatePosted + ": " + date;
            containerContentPurpose.innerHTML = _this.json.results[0].description;
            containerContentResponsibilities.innerHTML = _this.json.results[0].FLD_JPM_KEYRESPONSIBILITIES;
            containerContentQualifications.innerHTML = _this.json.results[0].FLD_JPM_PREFERRED_QUALIFICATION;
            // containerContentSummary.innerHTML = this.json.results[0].FLD_JPM_DIVISION_SUMMARY;
            containerButtons.map(function (container) {
                var buttonSave = container.querySelector('.button--white');
                buttonSave.setAttribute('data-postid', _this.json.results[0].jobPostId);
            });
            var checkSaved = checkIfSaved(storageCareers, _this.json.results[0].jobPostId);
            if (checkSaved) {
                containerButtons.map(function (container) {
                    var buttonSave = container.querySelector('.button--white');
                    buttonSave.classList.add('js-unsave-job');
                    buttonSave.innerHTML = buttonTextUnsaveJob;
                });
            }
            containerLoader.classList.add('d-none');
            containerContainer.classList.remove('d-none');
            createIframe(container, _this.json.results[0].potentialAction.url);
        }).catch(function (error) {
            console.log(error);
        });
    };
    CareersDetailComponent.prototype.checkIfSaved = function (storageCareers, jobPostId) {
        if (storageCareers === void 0) { storageCareers = ""; }
        if (jobPostId === void 0) { jobPostId = ""; }
        var exists = false;
        if (!localStorage.getItem('sbgCareersSaved')) {
            localStorage.setItem('sbgCareersSaved', JSON.stringify([]));
            storageCareers = localStorage.getItem('sbgCareersSaved');
        }
        else {
            storageCareers = storageCareers;
            if (storageCareers.includes(jobPostId.toString())) {
                exists = true;
            }
        }
        return exists;
    };
    CareersDetailComponent.prototype.saveJob = function (postId) {
        if (postId === void 0) { postId = ""; }
        var storage = this.storageCareers;
        storage.push(postId);
        localStorage.setItem('sbgCareersSaved', JSON.stringify(storage));
    };
    CareersDetailComponent.prototype.unsaveJob = function (postId) {
        if (postId === void 0) { postId = ""; }
        var storage = this.storageCareers;
        for (var i = 0; i < storage.length; i++) {
            if (storage[i] === postId) {
                storage.splice(i, 1);
            }
        }
        localStorage.setItem('sbgCareersSaved', JSON.stringify(storage));
    };
    CareersDetailComponent.prototype.createIframe = function (container, url) {
        if (container === void 0) { container = ""; }
        if (url === void 0) { url = ""; }
        var output = "";
        output += "<div class=\"careers-detail-component__iframe d-none\">";
        output += "<iframe src=\"" + url + "\" width=\"100%\" height=\"1200\" frameborder=\"0\"></iframe>";
        output += "</div";
        var docfragmentHTML = document.createDocumentFragment();
        docfragmentHTML.appendChild(document.createRange().createContextualFragment(output));
        container.appendChild(docfragmentHTML);
    };
    CareersDetailComponent.prototype.urlParams = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
            return null;
        }
        else {
            return decodeURI(results[1]) || 0;
        }
    };
    CareersDetailComponent.prototype.translations = function () {
        this.containerTranslateOverview.innerHTML = this.dataTranslateOverview;
        this.containerTranslatePurpose.innerHTML = this.dataTranslatePurpose;
        this.containerTranslateResponsibility.innerHTML = this.dataTranslateResponsibilities;
        this.containerTranslateQualifications.innerHTML = this.dataTranslateQualifications;
        // this.containerTranslatePromise.innerHTML = this.dataTranslatePromise;
    };
    return CareersDetailComponent;
}(Base));
export { CareersDetailComponent };



//////////////////
// WEBPACK FOOTER
// ./components/careers-detail-component/careers-detail-component.component.ts
// module id = 621
// module chunks = 0